<!--
  An ElInput with the same style as entity segments
  Using weird contenteditable HTML property

  As close as possible from element-ui input
  https://github.com/ElemeFE/element/blob/dev/packages/input/src/input.vue
-->

<template>
  <div :class="[
    'el-input',
    'el-entity-input',
    inputSize ? 'el-input--' + inputSize : '',
    {
      'is-disabled': inputDisabled,
      'el-input-group': $slots.prepend || $slots.append,
      'el-input-group--append': $slots.append,
      'el-input-group--prepend': $slots.prepend,
      'el-input--prefix': $slots.prefix || prefixIcon,
      'el-input--suffix': $slots.suffix || suffixIcon || clearable
    }
    ]"
    @mouseenter="hovering = true"
    @mouseleave="hovering = false"
  >
    <!-- 前置元素 -->
    <div class="el-input-group__prepend" v-if="$slots.prepend">
      <slot name="prepend"></slot>
    </div>
    <div
      class="el-input__inner el-entity-input__inner"
      @click="focus"
      ref="input"
    >
      <span :class="['el-entity-input__prefix', entityClass]" :style="styleObj">{{entityPrefix}}</span>
      <span
        :class="['el-entity-input__editable', entityClass]" :style="styleObj"
        :contenteditable="inputDisabled||readonly?'false':'true'"
        :tabindex="inputDisabled||readonly?-1:tabindex"
        v-bind="$attrs"
        ref="contenteditable"
        @compositionstart="handleComposition"
        @compositionupdate="handleComposition"
        @compositionend="handleComposition"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
        @keydown.enter.prevent="handleSubmit"
        :aria-label="label"
        autocomplete="off"
        autocorrect="off"
        autocapitalize="off"
        spellcheck="false">&#8203;</span>
      <span class="el-entity-input__info">{{' '}}
        <template v-if="info">{{ info }}</template>
        <slot v-else name="info"></slot>
      </span>
    </div>
    <!-- 前置内容 -->
    <span class="el-input__prefix" v-if="$slots.prefix || prefixIcon">
      <slot name="prefix"></slot>
      <i class="el-input__icon"
         v-if="prefixIcon"
         :class="prefixIcon">
      </i>
    </span>
    <!-- 后置内容 -->
    <span
      class="el-input__suffix"
      v-if="$slots.suffix || suffixIcon || showClear || validateState && needStatusIcon">
      <span class="el-input__suffix-inner">
        <template v-if="!showClear">
          <slot name="suffix"></slot>
          <i class="el-input__icon"
            v-if="suffixIcon"
            :class="suffixIcon">
          </i>
        </template>
        <i v-else
          class="el-input__icon el-icon-circle-close el-input__clear"
          @click="clear"
        ></i>
      </span>
      <i class="el-input__icon"
        v-if="validateState"
        :class="['el-input__validateIcon', validateIcon]">
      </i>
    </span>
    <!-- 后置元素 -->
    <div class="el-input-group__append" v-if="$slots.append">
      <slot name="append"></slot>
    </div>
  </div>
</template>
<script>
import emitter from 'element-ui/src/mixins/emitter'
import $ from 'jquery'

let EMPTY_CHAR = String.fromCharCode(8203)

export default {
  name: 'ElEntityInput',

  componentName: 'ElInput',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    elForm: {
      default: '',
    },
    elFormItem: {
      default: '',
    },
  },

  data () {
    return {
      hovering: false,
      focused: false,
      isOnComposition: false,
    }
  },

  props: {
    value: String,
    size: String,
    form: String,
    disabled: Boolean,
    readonly: Boolean,
    autosize: {
      type: [Boolean, Object],
      default: false,
    },
    autocomplete: {
      type: String,
      default: 'off',
    },
    validateEvent: {
      type: Boolean,
      default: true,
    },
    suffixIcon: String,
    prefixIcon: String,
    label: String,
    clearable: {
      type: Boolean,
      default: false,
    },
    tabindex: {
      type: [String, Number],
      default: '0',
    },
    // the type of entity, changes its style
    type: String,
    // the prefix to show
    prefix: String,
    // the info to show next to the name
    info: String,
    // the class to use
    className: String,
    // the style to apply
    styleObj: Object,
  },

  computed: {
    _elFormItemSize () {
      return (this.elFormItem || {}).elFormItemSize
    },
    validateState () {
      return this.elFormItem ? this.elFormItem.validateState : ''
    },
    needStatusIcon () {
      return this.elForm ? this.elForm.statusIcon : false
    },
    validateIcon () {
      return {
        validating: 'el-icon-loading',
        success: 'el-icon-circle-check',
        error: 'el-icon-circle-close',
      }[this.validateState]
    },
    inputSize () {
      return this.size || this._elFormItemSize || (this.$ELEMENT || {}).size
    },
    inputDisabled () {
      return this.disabled || (this.elForm || {}).disabled
    },
    nativeInputValue () {
      return this.value === null || this.value === undefined ? '' : this.value
    },
    showClear () {
      return this.clearable &&
          !this.inputDisabled &&
          !this.readonly &&
          this.nativeInputValue &&
          (this.focused || this.hovering)
    },
    entityPrefix () {
      if (this.prefix) return this.prefix
      else if (this.type === 'entity') return '@'
      else if (this.type === 'synonym') return '#'
      else if (this.type === 'variable') return '$'
      else return ''
    },
    entityClass () {
      return this.className || this.type && 'el-entity-input__' + this.type || ''
    },
  },

  watch: {
    value (val, old) {
      this.$nextTick(() => this.renderInput(val, old))
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.change', [val])
      }
    },
  },

  methods: {
    focus () {
      this.$refs.contenteditable.focus()
    },
    blur () {
      this.$refs.contenteditable.blur()
    },
    getMigratingConfig () {
      return {
        props: {
          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.',
        },
        events: {
          'click': 'click is removed.',
        },
      }
    },
    handleBlur (event) {
      this.focused = false
      this.$emit('blur', event)
      if (this.validateEvent) {
        this.dispatch('ElFormItem', 'el.form.blur', [this.value])
      }
    },
    select () {
      // manually selects the whole text
      const selection = window.getSelection()
      let range = new Range(), node = this.$refs.contenteditable.firstChild
      range.setStart(node, 0)
      range.setEnd(node, node.length)
      range.collapse(true)
      selection.removeAllRanges()
      selection.addRange(range)
      // $refs.contenteditable.select();
    },
    handleFocus (event) {
      this.focused = true
      this.$emit('focus', event)
    },
    handleComposition (event) {
      if (event.type === 'compositionstart') {
        this.isOnComposition = true
      }
      if (event.type === 'compositionend') {
        this.isOnComposition = false
        this.handleInput(event)
      }
    },
    handleInput (event) {
      if (this.isOnComposition) return

      let val = event.target.textContent.replace(EMPTY_CHAR, '')
      // hack for https://github.com/ElemeFE/element/issues/8548
      // should remove the following line when we don't support IE
      if (val === this.nativeInputValue) return

      this.$emit('input', val)
      this.$emit('change', val)

      // set input's value, in case parent refuses the change
      // see: https://github.com/ElemeFE/element/issues/12850
      this.$nextTick(() => this.renderInput(this.value, val))
    },
    // handleChange(event) {
    //   this.$emit('change', event.target.value);
    // },
    // submits to the form in enter
    handleSubmit () {
      $(this.$refs.contenteditable).closest('form').find('[type=submit]').click()
    },
    calcIconOffset (place) {
      let elList = [].slice.call(this.$el.querySelectorAll(`.el-input__${place}`) || [])
      if (!elList.length) return
      let el = null
      for (let i = 0; i < elList.length; i++) {
        if (elList[i].parentNode === this.$el) {
          el = elList[i]
          break
        }
      }
      if (!el) return
      const pendantMap = {
        suffix: 'append',
        prefix: 'prepend',
      }

      const pendant = pendantMap[place]
      if (this.$slots[pendant]) {
        el.style.transform = `translateX(${place === 'suffix' ? '-' : ''}${this.$el.querySelector(`.el-input-group__${pendant}`).offsetWidth}px)`
      } else {
        el.removeAttribute('style')
      }
    },
    updateIconOffset () {
      this.calcIconOffset('prefix')
      this.calcIconOffset('suffix')
    },
    clear () {
      this.$emit('input', '')
      this.$emit('change', '')
      this.$emit('clear')
    },
    renderInput (val, old) {
      const input = this.$refs.contenteditable
      val = val || EMPTY_CHAR
      if (input.textContent !== val) input.textContent = val
      // correct the cursor position if the input was previously empty
      if (!old) {
        const selection = window.getSelection()
        // check that the cursor is selected
        let anchor = selection.anchorNode
        if (!anchor || anchor !== input && anchor.parentNode !== input) return
        // move cursor at the end
        let range = new Range()
        range.setStart(input.firstChild, val.length)
        range.collapse(true)
        selection.removeAllRanges()
        selection.addRange(range)
      }
    },
  },

  created () {
    this.$on('inputSelect', this.select)
  },

  mounted () {
    this.updateIconOffset()
    this.renderInput(this.value, true)
  },

  updated () {
    this.$nextTick(this.updateIconOffset)
  },
}
</script>

<style lang="scss">
  @import "../../element-variables.scss";

  /* reproduce browser outline */
  .el-entity-input__inner:focus-within, .el-entity-input__inner:hover:focus-within {
    border-color: $--color-primary;
    outline: 0;
  }
  /* removes the browser outline from the contenteditabe */
  .el-entity-input__editable:focus {
    outline: 0;
  }
  /* style of entities */
  .el-entity-input__entity {
    background-color: $entity-bg-color;
  }
  .el-entity-input__synonym {
    background-color: $synonym-bg-color;
  }
  .el-entity-input__variable {
    background-color: $variable-bg-color;
  }
  /* ignores new lines */
  .el-entity-input__inner, .el-entity-input__inner * {
    white-space: nowrap;
    overflow: hidden;
  }
  .el-entity-input__inner br {
    display:none;
  }
  .el-entity-input__info {
    color: $--color-info;
  }
  /* avoid weird CSS bugs with height */
  .el-input.el-entity-input {
    height: $--input-height;
    cursor: text;
  }
</style>
